import button from "./blocks/button";
import divider from "./blocks/divider";
import image from "./blocks/image";
import gif from "./blocks/gif";
import product from "./blocks/product";
import raw from "./blocks/raw";
import social from "./blocks/social";
import spacer from "./blocks/spacer";
import text from "./blocks/text";
import video from "./blocks/video";
import dynamic from "./blocks/dynamic";
import premade from "./blocks/premade";
import carousel from "./blocks/carousel";
import article from "./blocks/article";
import customRaw from "./blocks/custom-raw";
import apiBlock from "./blocks/apiBlock";
import loopBlock from "./blocks/loopBlock";
import rating from "./blocks/rating";

export default (type: string) => {
  let block = null;
  switch (type) {
    case "button":
      block = button;
      break;
    case "dynamic":
      block = dynamic;
      break;
    case "divider":
      block = divider;
      break;
    case "gif":
      block = gif;
      break;
    case "image":
      block = image;
      break;
    case "product":
      block = product;
      break;
    case "raw":
      block = raw;
      break;
    case "social":
      block = social;
      break;
    case "spacer":
      block = spacer;
      break;
    case "text":
      block = text;
      break;
    case "video":
      block = video;
      break;
    case "premade":
      block = premade;
      break;
    case "carousel":
      block = carousel;
      break;
    case "article":
      block = article;
      break;
    case "custom-raw":
      block = customRaw;
      break;
    case "apiBlock":
      block = apiBlock;
      break;
    case "loop":
      block = loopBlock;
      break;
    case "rating":
      block = rating;
      break;
  }

  return block;
};
